import { MessageType } from "../../../../../../types/type";

interface Props {
    type: MessageType;
    commenterName?: string;
    formattedCreatedAt: string;
    isEdited: boolean;
}

export default function MessageHeader({ type, commenterName, formattedCreatedAt, isEdited, }: Props) {
    return (
        <div className={`mb-0.5 flex items-center gap-1 ${type === 'incoming' ? 'justify-start' : 'justify-end' }`}>
            <span className="max-w-[150px] truncate text-[10px] text-gray-500">
                {type === 'incoming' ? commenterName : 'You'}
            </span>
            <span className="text-[9px] text-gray-400">
                {formattedCreatedAt}
            </span>
            {isEdited && (
                <span className="text-[9px] italic text-gray-400">
                    Edited
                </span>
            )}
        </div>
    );
}